import lightGallery from 'lightgallery/dist/js/lightgallery'

jQuery(document).ready(function($) {

	$.lightgallery = {
		init: function() {
			
			$('.lightgallery').lightGallery({
				height: '700px',
				addClass: 'lg-fixed-size',
				download: false,
				startClass: '',
				enableSwipe: true,
				enableDrag: false,
				speed: 500,
				subHtmlSelectorRelative: true,
				autoplayControls: false,
				thumbnail: false,
				counter: true,
				mode: 'lg-fade',
				appendCounterTo: '.lg'
			});

		},
	};

});